module.exports = __webpack_public_path__ + "static/google-play-badge.db9b21a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/badges/google-play-badge.png
// module id = 356
// module chunks = 154382131621592